(function($) {

    $('#modalLocations').on('show.bs.modal', function(event) {
        var button = $(event.relatedTarget) // Button that triggered the modal
        var address = button.data('address') // Extract info from data-* attributes
        var modal = $(this);
        var iframe = $(this).find('iframe:first');

        iframe.attr('src', 'https://maps.google.com/maps?q=' + address + '&t=&z=13&ie=UTF8&iwloc=&output=embed');
    })
    $('#modalLocations').on('hidden.bs.modal', function(event) {
        var modal = $(this);
        var iframe = $(this).find('iframe:first');

        iframe.attr('src', '');
    })

    // Grab src from data atribute on button
    var videoSrc;

    $('.js-modal-trigger').on('click', function(e) {
        e.preventDefault();
        videoSrc = $(this).attr('data-src');
    });

    // Autoplay video when modal opens
    $('#modalVideo').on('shown.bs.modal', function(e) {
        $('#modalVideoSrc').attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    });

    // Stop playing play video when modal closes
    $('#modalVideo').on('hide.bs.modal', function(e) {
        $('#modalVideoSrc').attr('src', '');
    });

})(jQuery);